import { create } from 'zustand';
import packageService from '../services/package.service';

/**
 * Package Store - Quản lý state của packages
 * Cache packages để tránh gọi API nhiều lần
 */
const usePackageStore = create((set, get) => ({
  // State
  packages: [],
  loading: false,
  error: null,
  lastFetched: null, // Timestamp của lần fetch cuối

  // Actions
  setPackages: (packages) => set({ packages, error: null, lastFetched: Date.now() }),
  
  setLoading: (loading) => set({ loading }),
  
  setError: (error) => set({ error }),
  
  clearPackages: () => set({ packages: [], error: null, lastFetched: null }),

  /**
   * Fetch packages từ API
   * Chỉ fetch nếu chưa có data hoặc data đã cũ (> 5 phút)
   * @param {boolean} force - Force fetch ngay cả khi có cache
   */
  fetchPackages: async (force = false) => {
    const { packages, lastFetched, loading } = get();
    
    // Nếu đang loading, không fetch nữa
    if (loading) return packages;
    
    // Nếu có cache và chưa quá 5 phút, return cache
    const CACHE_TIME = 5 * 60 * 1000; // 5 phút
    if (!force && packages.length > 0 && lastFetched && (Date.now() - lastFetched < CACHE_TIME)) {
      return packages;
    }

    set({ loading: true, error: null });

    try {
      const response = await packageService.getAllPackages();
      
      if (response && response.payload) {
        const sortedPackages = response.payload.sort((a, b) => a.display_order - b.display_order);
        set({ 
          packages: sortedPackages, 
          loading: false, 
          error: null,
          lastFetched: Date.now()
        });
        return sortedPackages;
      } else {
        set({ loading: false, error: 'Không thể tải danh sách gói' });
        return [];
      }
    } catch (error) {
      set({ loading: false, error: error.message });
      return [];
    }
  },

  /**
   * Get package by ID
   */
  getPackageById: (id) => {
    const { packages } = get();
    return packages.find(pkg => pkg.id === id);
  },

  /**
   * Get package by code
   */
  getPackageByCode: (code) => {
    const { packages } = get();
    return packages.find(pkg => pkg.code === code);
  },
}));

export default usePackageStore;

